import { AxiosResponse } from "axios";
import { Http } from "../../Utils/Http";
import { IAPIErrorResponse } from "../Interfaces/Base/IAPIErrorResponse";
import { IResponse } from "../Interfaces/Base/IResponse";
import { IResponseDepoimentos } from "../Interfaces/Responses/Depoimentos/IResponseDepoimentos";

export interface IDepoimentosAPI {
  fetchDepoimentos(): Promise<
    AxiosResponse<IResponse<IResponseDepoimentos[]> | IAPIErrorResponse>
  >;
}

class DepoimentosAPI implements IDepoimentosAPI {
  async fetchDepoimentos(): Promise<
    AxiosResponse<IResponse<IResponseDepoimentos[]> | IAPIErrorResponse>
  > {
    const axios = await Http.axios();
    const response =
      axios.get<IResponse<IResponseDepoimentos[]> | IAPIErrorResponse>(
        `/api/depoimentos/all`
      );
    return response;
  }
}

const instance = new DepoimentosAPI();

export default instance;
